export default __webpack_public_path__ + "static/contact-780aef1d6bc2f9df52b4301e88630ea4.jpg";